import * as actionTypes from "../actions";
import secureStorage from "../../helpers/locStore";

const initialState = secureStorage.getItem("currency")
  ? secureStorage.getItem("currency")
  : "";
const currencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENCY:
      secureStorage.setItem("currency", action.payload);
      // console.log(action.payload);
      return (state = action.payload);
    default:
      secureStorage.setItem("currency", state);
      return state;
  }
};

export default currencyReducer;
